export default "/images/waves.svg?6d1cb7f935c695a448ab6534d1299ba0";